export default __webpack_public_path__ + "static/access-lock-7987ed24ef5268bac3fe79dd06b45484.svg";